




















import Vue from 'vue'

import { Find } from '@/api/user'
import { User } from '@/types/user'

import TableUser from './table-users.vue'

export default Vue.extend({
  name: 'UserManagement',
  components: {
    TableUser,
  },
  data() {
    return {
      users: [] as User[],
    }
  },
  methods: {
    async find() {
      this.users = await Find()
    },
    gotoNew() {
      this.$router.push('/cems/setting/user/create')
    },
  },

  async created() {
    await this.find()
  },
})
